import useActiveTabIndicator from 'hooks/useActiveTabIndicator';

/**
 * Tabs underlined in orange, as on the prototype's panels (a task's
 * « Détail · Activité · Commentaires »): grey labels on a grey line, the
 * active one orange, its underline sliding from tab to tab once measured.
 * `tabs` is a list of { id, label }; `className` places the strip.
 */
const LineTabs = ({ tabs, activeTab, onChange, className = '' }) => {
  const { listRef, registerTab, indicator } = useActiveTabIndicator(
    activeTab,
    tabs.map((tab) => tab.id),
  );
  return (
    <div ref={listRef} role="tablist" className={`relative flex gap-5 border-b border-gray-100 ${className}`}>
      {tabs.map((tab) => {
        const active = tab.id === activeTab;
        // Once the sliding bar is measured, the active tab keeps a
        // transparent border so its height, and what is below, do not move.
        const underline = active && !indicator ? 'border-b-yellow-500' : 'border-b-transparent';
        return (
          <button
            key={tab.id}
            ref={registerTab(tab.id)}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.id)}
            className={`-mb-px border-b-2 pb-3 text-sm font-normal transition-colors ${underline} ${
              active ? 'text-yellow-500' : 'text-gray-600 hover:border-b-gray-200 hover:text-gray-700'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
      {indicator && (
        <span
          data-testid="tab-indicator"
          aria-hidden="true"
          className="pointer-events-none absolute -bottom-px h-0.5 bg-yellow-500 motion-safe:transition-[left,width] motion-safe:duration-[250ms] motion-safe:ease-[cubic-bezier(0.22,1,0.36,1)]"
          style={{ left: indicator.left, width: indicator.width }}
        />
      )}
    </div>
  );
};

export default LineTabs;
